import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [
    { path: '/', name: 'home', component: HomeView },
    { path: '/services', name: 'services', component: () => import('../views/ServicesView.vue') },
    { path: '/references', name: 'references', component: () => import('../views/ReferencesView.vue') },
    { path: '/contact', name: 'contact', component: () => import('../views/ContactView.vue') },
    { path: '/fences', name: 'fences', component: () => import('../views/FencesView.vue') },
    { path: '/:catchAll(.*)*', name: 'notfound', component: () => import('../views/NotFoundView.vue') }
  ]


const router = createRouter({
  history: createWebHistory('/'),
  routes
})

export default router
